"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormCheck = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const form_utils_1 = require("../../../utils/form.utils");
const BronsonFormCheck = (props) => {
    const [hasError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState([]);
    return (React.createElement(React.Fragment, null,
        React.createElement(bronson_react_1.Checkbox, { id: (0, form_utils_1.generateElementId)(props.elementId), name: props.group, onChange: (event) => {
                (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onChange, props.validations);
            }, defaultValue: props.defaultValue, checked: props.checked, disabled: props.isDisabled, error: props.hasError || hasError }, props.label && (0, form_utils_1.renderLabel)(props.label, props.validations)),
        (0, form_utils_1.renderError)(hasError, errorMessage, props.hasError, props.errorMessage)));
};
exports.BronsonFormCheck = BronsonFormCheck;
